import { Component } from '@angular/core';
import { CustomerDetailsService } from "../Customerdashboard/customerdetails.service";
import { CustomerDetailsType } from "../Customerdashboard/customerdetailstype";
import { ActivatedRoute } from '@angular/router';
import { ProductService } from "../providers/products.service";
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../providers/lang.service';
import { CustomCookieService } from '../providers/mycookie.service';
import { DatePipe } from '@angular/common';
import { Router, NavigationStart } from '@angular/router';
import { CustomStorage } from '../providers/Custom-storage.service';
import { Observable, Subject } from 'rxjs';
import { ProductSearchService } from "../commonnavbar/productsearch";
import { RestApiServices } from '../providers/rest.service';
import { SharedServiceService } from '../shared/shared-service.service';
import { Location } from '@angular/common';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from '../auth.service';
import { CartitemsService } from '../providers/cartitems.service';
import { LoaderComponent } from '../loader/loader.component';
import { Constant } from '../Constant'


@Component({
  selector: 'commonnavbar',
  templateUrl: './commonnavbar.component.html',
  styleUrls: ['../app.component.css']


})
export class CommonNavbarComponent implements OnInit {

  errorDialog: boolean = false;
  emptycartdialog: boolean = false;
  errorData: any = {};
  productStatus: boolean = false;
  name: any; yes: string = "";no: string = "";confirmation: string = "";log_out: string = "";
  shoppingdialog = false;
  internet_check: String = ""; shoppinglabel: string = ""; inspired: string = ""; empty_cart: string = ""
  customerdetailsData: any = [];
  custID: string;
  cartlist = [];
  public openedcart: boolean = true;
  showDialog: boolean = false;
  public flag: boolean = true;
  cartItemsCount = 0;
  backbutton: boolean = true;
  //myCartItem=[]
  private subscription: Subscription = new Subscription();
  cartItems = [];
  constructor(private customerdetailService: CustomerDetailsService, private langService: LanguageService,
    route: ActivatedRoute, public router: Router, private cookieService: CustomCookieService,
    private localStorage: CustomStorage, private restApi: RestApiServices, private search: ProductSearchService,
    private sharedService: SharedServiceService, private localCart: CartitemsService,
    private location: Location, private authService: AuthService) {

  }

  ngOnInit() {
    
      // if(this.productStatus == true){
    this.localCart.fireCartList();

    // this.localCart.cartList.subscribe(res => {
    //   this.cartItemsCount = res.length;
    // });
    this.localCart.cartList.subscribe(res => {
      this.cartItems = res;
      this.cartItemsCount = this.cartItems.length;
      });
   // }
     
    this.productStatus = this.sharedService.getProductSearchFlag();

    this.sharedService.getProductStatus().subscribe(flag => {
      this.productStatus = flag;
    });
    
    this.backbutton = this.sharedService.getBackbuttonFlag();

    this.sharedService.getBackButton().subscribe(flag => {
      this.backbutton = flag;
    });
    
    this.langService.getJson().subscribe(data => {
      this.setLabels();
    });

    this.localStorage.getItem('customer').subscribe(result => {
      this.customerdetailsData = result.response.data;
      console.log(this.customerdetailsData);
      this.sharedService.setDoNotAllowNegativeInvOrder(this.customerdetailsData.do_not_allow_negative_inv_order);
      this.sharedService.setAllowTopSellingItems(this.customerdetailsData.top_selling_item_active);
      this.sharedService.setAllowInspiredByPurchaseHistory(this.customerdetailsData.inspired_by_purchase_history_active);
    });
    //console.log(this);
  }

  setLabels() {

    this.langService.getLangLabelValue("LblShoppingCart").then(res => {
      this.shoppinglabel = res;
    });
    this.langService.getLangLabelValue("LblInspiredByPurchasingHistory").then(result => {
      this.inspired = result;
    });
    this.langService.getLangLabelValue("LblYes").then(result => {
      this.yes = result;
    });
    this.langService.getLangLabelValue("LblNo").then(result => {
      this.no = result;
    });
    this.langService.getLangLabelValue("LblLogoutMessage").then(result => {
      this.confirmation = result;
    });
    this.langService.getLangLabelValue("LblLogout").then(result => {
      this.log_out = result;
    });
    this.langService.getLangLabelValue("200_empty_cart").then(result => {
      this.empty_cart = result;
    });
  }

  public opencart() {
    this.openedcart = true;
  }

  public closecart(status) {
    this.openedcart = false;
  }

  logout() {
    LoaderComponent.loadingV.next(true);
    this.restApi.logout().subscribe(res => {
      if (res) {
        let languagevalue = this.cookieService.getCookieData(Constant.KEY_CDISELECTEDLANGUAGE);
        this.authService.logout();
        LoaderComponent.loadingV.next(false);
        // this.localStorage.emptyStorage();
        this.sharedService.removeAllData()
        this.router.navigate(['/login', {'region': languagevalue}]);
      }
      //console.log(res);
    }, error => {
      this.errorData = error;
    });

  }

  backButton() {
    
    this.location.back();
  }
  showCartItem()
  {
      if(this.cartItemsCount > 0) {
      this.shoppingdialog = !this.shoppingdialog;
    // this.cartItems=this.localCart.getCartItems()
      LoaderComponent.loadingV.next(true);
          // this.restApi.getcartproducts().subscribe(data =>{          
            this.localCart.loadCartItems()
            LoaderComponent.loadingV.next(false);
          // })        
      }
      else{
        this.emptycartdialog = !this.emptycartdialog;
      }
  
  }

}



// WEBPACK FOOTER //
// ./src/app/commonnavbar/commonnavbar.component.ts